import { useSelector, shallowEqual } from 'react-redux';
import { PAYMENT_NAMES, PAYMENT_METHODS } from 'config/app-config';
import { selectPaymentMethod } from 'state/payment-method/payment-method-slice';
import { usePaymentMethod } from 'hooks/usePaymentMethod';
import { usePaymentOptions } from 'hooks/usePaymentOptions';
import { selectFuelType } from 'state/fuel-type/fuel-type-slice';
import { selectPersonaliseQuoteShowFuel } from 'state/settings/settings-slice';
import { selectValidationRequired } from 'state/meterpoint-validation/meterpoint-validation-slice';
import { useMeterExceptions } from 'components/direct-sales/select-options/hooks/useMeterExceptions';

export const useEnergyNeedsScreen = () => {
  const { isMonthlyDirectDebit } = usePaymentMethod();
  const meterValidationRequired = useSelector(
    selectValidationRequired,
    shallowEqual
  );
  const isMeterValidationRequired = Object.values(meterValidationRequired).some(
    (v) => v
  );
  const paymentMethodValue = useSelector(selectPaymentMethod, shallowEqual);
  const paymentOptions = usePaymentOptions();
  const displayedPaymentOptions = paymentOptions.map((paymentOption) => ({
    label: PAYMENT_NAMES[paymentOption],
    value: paymentOption
  }));

  const isPrePayOnly =
    paymentOptions.length === 1 &&
    paymentOptions.includes(PAYMENT_METHODS.PREPAY);

  const canChoosePaymentMethod = paymentOptions.length > 1;
  const fuelType = useSelector(selectFuelType, shallowEqual);
  const showFuelType = useSelector(
    selectPersonaliseQuoteShowFuel,
    shallowEqual
  );
  const { hasMeterExceptions } = useMeterExceptions();

  const hideFuelType = !showFuelType;
  const hideEV =
    !fuelType.electric ||
    !isMonthlyDirectDebit ||
    isMeterValidationRequired ||
    hasMeterExceptions;
  const hidePaymentMethod =
    !canChoosePaymentMethod || isMeterValidationRequired || hasMeterExceptions;
  const hideConsumption = isMeterValidationRequired || hasMeterExceptions;
  const defaultPaymentMethod = paymentOptions[0];

  return {
    isPrePayOnly,
    paymentMethodValue,
    displayedPaymentOptions,
    defaultPaymentMethod,
    canChoosePaymentMethod,
    hideFuelType,
    hideEV,
    hidePaymentMethod,
    hideConsumption
  };
};
